import { call, put, takeEvery } from 'redux-saga/effects'
import API from '../../API';
// import {toastr} from 'react-redux-toastr'
import axios from 'axios';
import Cookies from 'js-cookie';

async function getApi(data) {
    const apiUrl = API.baseURL + `/user_profile.json`;
    try {
        const response = await axios.get(apiUrl, API.options)
        console.log(response,'response');
        // Set cookie with name from response
        if (response?.data?.data?.name) {
            Cookies.set('name', response.data.data.name);
        }
        return await response;
    } catch (error) {
        throw error;
    }
}

function* getProfileData(action) {
    try {
        const response = yield call(getApi, action.data);
        if (response.status == 200 || response.status == 201) {
            // toastr.success('Pegister personal Success', 'You are successfully completed the first step ');
        } else {
            // response.errors.length!=0&&toastr.error('Pegister personal  failed', response.errors[0]);
        }
        yield put({ type: 'GET_PROFILE_DATA_SUCCESS', data: response.data.data });
    } catch (e) {
        yield put({ type: 'GET_PROFILE_DATA_FAILED', message: e.message });
    }
}

function* getProfileDataSaga() {
    yield takeEvery('GET_PROFILE_DATA_REQUESTED', getProfileData);
}

export default getProfileDataSaga;